import { useDispatch, useSelector } from "react-redux";
import Heading from "../../../components/heading/Heading";
import Loadable from "../../../components/loadable/Loadable";
import TabbedNavigationWithDefinedTitle from "../../../components/tabbednavigation/TabbedNavigationWithDefinedTitle";
import commonStyles from "../FormSection.styles"
import { IRST_STATE_REJECTED_PATHS } from "./constant";
import { componentKey, setCurrentTabIndex } from "./IrsStateRejectedSlice";
import { HEADING } from "../../../components/heading/constants/constants";
import { useEffect } from "react";
import FederalResubmitForms from "./federalresubmit/FederalResubmit";
import StateResubmit from "./stateresubmit/StateResubmit";
import ReconciliationResubmitForms from "./reconciliationresubmit/ReconciliationResubmit";
import StatePayrollResubmitForms from "./statepayrollresubmit/StatePayrollResubmit";
import { useLocation } from "react-router-dom";
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks";
import { FEATURE_FLAG } from "../../../featureFlags";

export default function IrsStateRejected() {
    useGarbageCollector(componentKey)

    const dispatch = useDispatch();
    const location = useLocation();
    const { currentTabIndex } = useSelector(state => state[componentKey]);

    useEffect(() => {

        const paths = location.pathname.split("/");
        const currentPath = paths[paths.length - 1];
        let index = 0;

        switch (currentPath) {
            case IRST_STATE_REJECTED_PATHS.FEDERAL_RESUBMIT:
                index = 0;
                break;

            case IRST_STATE_REJECTED_PATHS.STATE_RESUBMIT:
                index = 1;
                break;

            case IRST_STATE_REJECTED_PATHS.RECONCILIATION_RESUBMIT:
                index = 2;
                break;

            case IRST_STATE_REJECTED_PATHS.STATE_PAYROLL_RESUBMIT:
                index = 3;
                break;
        }

        dispatch(setCurrentTabIndex(index));
    }, [location])

    const tabListWithTitleObj = [
        {
            title: {
                titleText: "Federal Resubmit",
            },
            tabBodyComponent: <FederalResubmitForms />,
            linkTo: `/${IRST_STATE_REJECTED_PATHS.FEDERAL_RESUBMIT}`
        },
        {
            title: {
                titleText: "State Resubmit",
            },
            tabBodyComponent: <StateResubmit />,
            linkTo: `/${IRST_STATE_REJECTED_PATHS.STATE_RESUBMIT}`
        },
        ...(FEATURE_FLAG.SHOW_RECONCILIATION ? [{
            title: {
                titleText: "Reconciliation Resubmit",
            },
            tabBodyComponent: <ReconciliationResubmitForms />,
            linkTo: `/${IRST_STATE_REJECTED_PATHS.RECONCILIATION_RESUBMIT}`
        }] : [])
        ,
        ...(FEATURE_FLAG.SHOW_STATE_PAYROLL ? [{
            title: {
                titleText: "State Payroll Resubmit",
            },
            tabBodyComponent: <StatePayrollResubmitForms />,
            linkTo: `/${IRST_STATE_REJECTED_PATHS.STATE_PAYROLL_RESUBMIT}`
        }] : [])
    ];

    return (
        <div style={commonStyles.gridContainer}>
            <TabbedNavigationWithDefinedTitle
                tabListWithTitleObj={tabListWithTitleObj}
                useSeparateUrl={true}
                sectionPath={"/forms/irsstaterejected"}
                activeTabIndex={currentTabIndex}
                onChangeTabCb={(activeTabIdx) => dispatch(setCurrentTabIndex(activeTabIdx))}
                unMountChildComponentOnSwitch={true}
            />
        </div>
    )
}